import React from "react";
import ReactModal from "react-modal";
import { useNavigate } from "react-router-dom";

const ALevelMenu = ({ data }) => {
  const [showmodal, setshowmodal] = React.useState(false);
  const navigate = useNavigate();
  return (
    <>
      <ReactModal isOpen={showmodal} onRequestClose={() => setshowmodal(false)} className="ReactModal">
        <div className="modal-dialog " role="document">
          <div className="modal-content">
            <div className="modal-header ">
              <div></div>
              <span className="pointer text-right text-danger" onClick={() => setshowmodal(false)}>
                x
              </span>
            </div>
            <div className="modal-body">
              <div className="col-md-12 my-3 pointer" onClick={() => navigate("/app/olevel")}>
                <div className="card-counter info">
                  <i className="fa fa-solid fa-square-poll-vertical"></i>
                  <span className="count-numbers">Examination Sitting</span>
                  <span className="count-name">Students are allowed to have up to 2 sittings</span>
                </div>
              </div>
              <div className="col-md-12 my-3 pointer" onClick={() => navigate("/app/olevelresult")}>
                <div className="card-counter info">
                  <i className="fa fa-solid fa-square-poll-vertical"></i>
                  <span className="count-numbers">Examination Result</span>
                  <span className="count-name">Students can add results based on the sittings</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
      <div className="col-md-4 my-3 pointer" onClick={() => setshowmodal(true)}>
        <div className={`card-counter ${data?.olevel >= 1 ? (data.result >= 6 ? "success" : "info") : "danger"}`}>
          <i className="fa fa-solid fa-square-poll-vertical"></i>
          <span className="count-numbers">O-Level</span>
          <span className="count-name">Secondary Results</span>
        </div>
      </div>
    </>
  );
};

export default ALevelMenu;
